import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { TECH_STACK, PARTNER_LOGOS } from "@/data/techStack";

// Detect mobile to slow the marquee further
function useIsMobile(breakpoint = 768) {
  const [m, setM] = useState(typeof window !== "undefined" ? window.innerWidth < breakpoint : false);
  useEffect(() => {
    const fn = () => setM(window.innerWidth < breakpoint);
    fn();
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, [breakpoint]);
  return m;
}

export function TechStackGrid() {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 border-l border-t border-[#1f1f22]">
      {TECH_STACK.map((t) => (
        <div
          key={t.name}
          data-testid={`tech-${t.name.toLowerCase().replace(/\W+/g, "-")}`}
          className="border-r border-b border-[#1f1f22] flex flex-col items-center justify-center gap-3 p-6 bg-[#0B0B0D] hover:bg-[#0E0E10] transition-colors group min-h-[120px]"
        >
          <img
            src={t.icon}
            alt={t.name}
            className={`${t.wide ? "h-7 max-w-[80px]" : "w-9 h-9"} object-contain opacity-70 group-hover:opacity-100 transition-opacity`}
            loading="lazy"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <div className="label-mono text-[10px] text-zinc-500 group-hover:text-zinc-300 transition-colors">{t.name}</div>
        </div>
      ))}
    </div>
  );
}

export function TechStackMarquee() {
  const isMobile = useIsMobile();
  return (
    <div className="marquee-mask py-6">
      <Marquee gradient={false} speed={isMobile ? 18 : 28} pauseOnHover>
        {TECH_STACK.concat(TECH_STACK).map((t, i) => (
          <div key={i} className="mx-10 flex items-center gap-3 opacity-70 hover:opacity-100 transition-opacity">
            <img
              src={t.icon}
              alt={t.name}
              className={`${t.wide ? "h-5 max-w-[60px]" : "w-7 h-7"} object-contain`}
              loading="lazy"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
            <span className="font-display font-medium text-2xl text-zinc-400">{t.name}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export function PartnersStrip() {
  const isMobile = useIsMobile();
  return (
    <div className="border-y border-[#1f1f22] py-10 bg-[#0B0B0D]">
      <div className="container-x">
        <div className="label-mono text-center mb-6">// Trusted by teams using</div>
      </div>
      <div className="marquee-mask">
        <Marquee gradient={false} speed={isMobile ? 10 : 18} pauseOnHover>
          {PARTNER_LOGOS.concat(PARTNER_LOGOS).map((l, i) => (
            <div key={i} className="mx-12 flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity">
              <img
                src={l.icon}
                alt={l.name}
                className="w-6 h-6 object-contain"
                loading="lazy"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
              <span className="font-display font-medium text-xl text-zinc-500">{l.name}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
}
